<template>
	<div>
		<p><strong v-text="type"></strong></p>
		<apex-charts
			v-if="showApexChart"
			:data="detail"
			:source="source"
		></apex-charts>
		<component :is="type" v-else :data="detail" :source="source" />
		<hr />
	</div>
</template>

<script>
import { mapGetters } from "vuex";

import {
	ApexCharts,
	score,
	sourcePath,
	excel,
	tabular
} from "@shared/Charts/utils";
export default {
	name: "ChartView",
	components: {
		ApexCharts,
		score,
		excel,
		tabular
	},
	props: {
		type: {
			type: String,
			default: () => null
		},
		name: {
			type: String,
			default: () => null
		}
	},
	computed: {
		...mapGetters({
			query: "reportQueries/query"
		}),
		chartType() {
			return this.type === "table" ? "tablular" : this.type;
		},
		source() {
			const path = sourcePath(
				`/charts/hospital/{HospitalID}/${this.name}/${this.type}/`,
				{
					hospitalid: 1
				}
			);
			return `${path}?${this.query}`;
		},
		sourceURL() {
			return this.$config.apiURL;
		},
		detail() {
			return {
				highlight: false,
				source: this.source,
				title: null,
				hideborder: false,
				downloadlabel: null
			};
		},
		showApexChart() {
			return [
				"pie",
				"donut",
				"column",
				"radialbarmultiple",
				"timeline",
				"timelineday",
				"scoreovertime"
			].includes(this.type);
		}
	}
};
</script>
